import { render, staticRenderFns } from "./value-selector.vue?vue&type=template&id=6464c890&scoped=true&"
import script from "./value-selector.vue?vue&type=script&lang=js&"
export * from "./value-selector.vue?vue&type=script&lang=js&"
import style0 from "./value-selector.vue?vue&type=style&index=0&id=6464c890&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6464c890",
  null
  
)

export default component.exports